import { Input } from "@biteship/atom";

export default function ProfileDetails({
  user,
  courierName,
  courierType,
}) {
  return (
    <div className="space-y-4 w-full md:w-1/2">
      <Input
        label="Nama Depan"
        labelClassName="text-gray-900 font-bold"
        name="firstName"
        value={user?.firstName || ""}
        disabled
      />
      
      <Input
        label="Nama Belakang"
        labelClassName="text-gray-500 font-bold"
        name="lastName"
        value={user?.lastName || ""}
        disabled
      />

      <Input
        label="Nama Kurir"
        name="courierName"
        value={courierName}
        disabled
      />

      <Input
        label="Kode Kurir"
        name="courierCode"
        value={user?.courier?.courierCode || ""}
        disabled
      />

      <Input
        label="Tipe Kurir"
        name="courierType"
        value={courierType}
        disabled
      />

      <Input
        label="Nomor HP Kontak"
        name="phone"
        value={user?.phone || ""}
        disabled
      />

      <Input
        className="bg-red-500"
        label="Admin Approval"
        name="adminApproval"
        value={user?.courier?.status === "active" ? "Approved" : "Not Approved"}
        disabled
      />
    </div>
  )
}